/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateStockReceiptDto } from '../../models/create-stock-receipt-dto';
import { StockReceipt } from '../../models/stock-receipt';

export interface StockReceiptsControllerCreate$Params {
      body: CreateStockReceiptDto
}

export function stockReceiptsControllerCreate(http: HttpClient, rootUrl: string, params: StockReceiptsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<StockReceipt>> {
  const rb = new RequestBuilder(rootUrl, stockReceiptsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StockReceipt>;
    })
  );
}

stockReceiptsControllerCreate.PATH = '/stock/receipts';
